var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTableR(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Table-r"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 24V7C3 6.44772 3.44772 6 4 6H28C28.5523 6 29 6.44772 29 7V24C29 24 29 24.8284 28.4142 25.4142C28.4142 25.4142 27.8284 26 27 26H5C5 26 4.17157 26 3.58579 25.4142C3.58579 25.4142 3 24.8284 3 24ZM5 24H27V8H5V24Z",
    fill: "#64A70B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 14H28C28.5523 14 29 13.5523 29 13C29 12.4477 28.5523 12 28 12H4C3.44772 12 3 12.4477 3 13C3 13.5523 3.44772 14 4 14Z",
    fill: "#64A70B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20H28C28.5523 20 29 19.5523 29 19C29 18.4477 28.5523 18 28 18H4C3.44772 18 3 18.4477 3 19C3 19.5523 3.44772 20 4 20Z",
    fill: "#64A70B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13V25C10 25.5523 10.4477 26 11 26C11.5523 26 12 25.5523 12 25V13C12 12.4477 11.5523 12 11 12C10.4477 12 10 12.4477 10 13Z",
    fill: "#64A70B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableR);
export default __webpack_public_path__ + "static/media/Table-r.5beb17c00d73a8dfb877b40491dcbc03.svg";
export { ForwardRef as ReactComponent };